interface ErrorStateProps {
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
}

export default function ErrorState({ message, retryLabel = '重试', onRetry }: ErrorStateProps) {
  return (
    <div className='bg-orange-50 border border-orange-200 text-orange-700 px-4 py-3 rounded-xl text-[0.875rem]'>
      <div className='flex items-center justify-between gap-3'>
        <span>{message}</span>
        {onRetry ? (
          <button type='button' className='btn btn-secondary shrink-0' onClick={onRetry}>
            {retryLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
